// extracted by mini-css-extract-plugin
export default {"default":"default--tIuff","success":"success--il92a","alert":"alert--P85F9","error":"error--MmR5I"};